"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SYSTEM_SETTINGS = void 0;
exports.SYSTEM_SETTINGS = Object.freeze({
    OVERNIGHT_RATE: 'overnight_rate',
});
//# sourceMappingURL=systemSettings.js.map